import { render, staticRenderFns } from "./CreateBookingForm.vue?vue&type=template&id=b70c8fb0"
import script from "./CreateBookingForm.vue?vue&type=script&lang=js"
export * from "./CreateBookingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports